import { FeatureFlagType } from '~/enums/FeatureFlagType';
import { Permission } from '~/types/Permission';

import { testHasFlag } from './utils/testHasFlag';

export const canUseWorkflow: Permission = testHasFlag(FeatureFlagType.Workflow);
